import { useScrollReveal } from '@/hooks/useScrollReveal';

const benefits = [
  { icon: 'ri-money-dollar-circle-line', title: 'Competitive Compensation', desc: 'Salary + equity. We want everyone to think and act like an owner — so we make everyone one.' },
  { icon: 'ri-hospital-line', title: 'Health & Wellness', desc: 'Comprehensive health coverage for you and your family. Mental health support included.' },
  { icon: 'ri-calendar-line', title: 'Flexible Time Off', desc: 'Take the time you need. We care about outcomes, not hours logged.' },
  { icon: 'ri-mac-line', title: 'Remote-First Culture', desc: 'Work from wherever you do your best work. We have hubs in Bengaluru, Kochi, and Mumbai for those who prefer an office.' },
  { icon: 'ri-book-open-line', title: 'Learning Budget', desc: 'Annual stipend for courses, conferences, books — whatever helps you grow.' },
  { icon: 'ri-restaurant-line', title: 'Team Rituals', desc: 'Quarterly offsites, team dinners, and a genuine culture of celebrating wins — big and small.' },
];

export default function BenefitsSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-secondary-50/30">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 border border-primary-200/50 mb-4">
            <span className="text-xs font-semibold text-primary-700 uppercase tracking-wider">Benefits</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary-700 mb-4">
            What We Offer
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm leading-relaxed">
            We invest in our people — not just with compensation, but with everything you need to do your best work.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {benefits.map((b) => (
            <div key={b.title} className="group bg-card-50 rounded-xl border border-card-200 p-5 shadow-sm hover:shadow-md hover:border-primary-200/40 transition-all cursor-default flex items-start gap-4 card-animate">
              <div className="w-10 h-10 rounded-lg bg-primary-50 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-100 transition-colors animate-icon-float icon-hover-pop">
                <i className={`${b.icon} text-lg text-primary-600`}></i>
              </div>
              <div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5">{b.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}